import React from 'react';
import './Information.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

const Information = () => {
    return (
        <div className="information-section">
            <div className="container">
                <div className="info-main-content">
                    <div className="info-left">
                        <div className="info-item">
                            <h4>Explore</h4>    
                        </div>
                        <div className="info-item social">
                            <a href="https://www.instagram.com/elite.partyz/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.facebook.com/elitepartyz.io/"><FontAwesomeIcon icon={faFacebook} /></a>
                        </div>
                    </div>
                    <div className="info-right">
                        <div className="info-item">
                            <h4>Contact</h4>
                        </div>
                        <div className="info-item">
                            <a href="mailto:contact@elitepartyz.com">contact@elitepartyz.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Information
